import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { HTTPService } from "../../common/services/httpService";
import { ISharedFile, ISharedFileDeleteRequest, ISharedFileUploadRequest, IShareFileShareRequest } from "./sharedFilesModel";

const httpService = new HTTPService();
const fileUpload = (files: File[], uploadRequest: ISharedFileUploadRequest): Promise<IHTTPResponse<IAPIResponse<any>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SharedFileUpload
        }`;
    const formData = new FormData();
    files.forEach((file) => { formData.append('files', file) });

    formData.append('purpose', uploadRequest.purpose.toString());


    return httpService.fileUpload(url, formData);
};

const getEbhyasFiles = (schoolId?: number): Promise<IHTTPResponse<IAPIResponse<ISharedFile>>> => {
    const baseUrl = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.EAbhyasSharedFiles}`;
    const url = schoolId ? `${baseUrl}?schoolId=${schoolId}` : baseUrl;

    return httpService.get(url);
}

const getSchoolFiles = (schoolId?: number): Promise<IHTTPResponse<IAPIResponse<ISharedFile>>> => {
    const baseUrl = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SchoolSharedFiles}`;
    const url = schoolId ? `${baseUrl}?schoolId=${schoolId}` : baseUrl;

    return httpService.get(url);
}

const getNotificationFiles = (): Promise<IHTTPResponse<IAPIResponse<ISharedFile>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.NotificationFiles}`;

    return httpService.get(url);
}

const deleteFile = (deleteFileRequest: ISharedFileDeleteRequest): Promise<IHTTPResponse<IAPIResponse<ISharedFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SharedFileDelete}`;

    return httpService.post(url, deleteFileRequest);
}
const shareFile = (fileShareRequest: IShareFileShareRequest): Promise<IHTTPResponse<IAPIResponse<ISharedFile>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SharedFileShare}`;

    return httpService.post(url, fileShareRequest);
}

const getFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.SharedFileDownload}/${fileId}`;

    return url;
}

const SharedFileService = {
    fileUpload,
    getEbhyasFiles,
    deleteFile,
    getFileDownloadUrl,
    shareFile,
    getSchoolFiles,
    getNotificationFiles

};

export default SharedFileService;